<template>
    <div class="image-uploader-wrapper">
        <ul class="image-uploader-list" tag="ul" name="list">
            <li class="image-uploader-list-item image" v-for="item in images" :key="item[opts.id] !== undefined ? item[opts.id] : item.uid">
                <img class="image-uploader-list-item-img" :src="item[opts.url]">
                <div class="progress-bar" v-if="item.status !== undefined && item.percentage !== undefined">
                    <div class="progress" :class="[item.status]" :style="{width: item.percentage + '%'}"></div>
                    <p class="progress-text">{{getUploadStatus(item)}}</p>
                </div>
                <div class="image-name" :title="item[opts.name]">{{item[opts.name]}}</div>
                <button title="删除" class="uploader-delete-btn" type="button" @click.stop="onDeleteFile(item)"><i class="jc-icon icon-delete"></i></button>
            </li>
            <li class="image-uploader-list-item uploader" :key="'uploader'" v-show="images && images.length < limit">
                <el-upload
                    v-if="local"
                    class="image-uploader"
                    ref="uploader"
                    :action="serverURL"
                    :show-file-list="false"
                    :on-progress="onProgress"
                    :on-success="onSuccess"
                    :on-error="onError"
                    :before-upload="onBeforeUpload"
                    :auto-upload="autoUpload"
                    :disabled="disabled">
                    <i class="jc-icon icon-add image-uploader-plus"></i>
                    <p class="image-uploader-tip">上传图片</p>
                    <div class="uploader-mask" @mouseover.stop="onMouseover" @mouseleave.stop="onMouseleave"></div>
                    <p class="uploader-tips" :class="[tipClass]" slot="tip">{{tip}}</p>
                </el-upload>
                <div class="image-uploader" v-else @click.stop="visible = true">
                    <i class="jc-icon icon-add image-uploader-plus"></i>
                    <p class="image-uploader-tip">上传图片</p>
                    <div class="uploader-mask" @mouseover.stop="onMouseover" @mouseleave.stop="onMouseleave"></div>
                    <p class="uploader-tips" :class="[tipClass]" slot="tip">{{tip}}</p>
                </div>
                <pictures :props="{name: opts.name, url: opts.url}" v-if="!local" :default-checked-list="images" v-model="visible" clear @on-confirm="onConfirm" :limit="limit"/>
            </li>
        </ul>
    </div>
</template>

<script>
import dom from '@/utils/dom'
import Pictures from '@/components/element'
export default {
  name: 'image-uploader',
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    width: {},
    height: {},
    limit: {
      type: Number,
      default: Infinity
    },
    statusText: {
      type: Object,
      default () {
        return {
          wait: '待上传...',
          fail: '上传失败',
          success: '上传完成'
        }
      }
    },
    beforeUpload: Function,
    autoUpload: {
      type: Boolean,
      default: true
    },
    accept: {
      type: Array,
      default () {
        return []
      }
    },
    drag: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    maxSize: Number,
    tipClass: String,
    options: {
      type: Object,
      default () {
        return {}
      }
    },
    serverURL: {
      type: String,
      default: '/eshop/pub/file/upload/add'
    },
    tip: String,
    local: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Pictures
  },
  watch: {
    value () {
      this.images = this.value
    },
    options () {
      this.opts = Object.assign({}, this.defaultOptions, this.options)
    }
  },
  data () {
    return {
      images: [],
      defaultOptions: {
        url: 'url',
        name: 'name',
        size: 'size',
        type: 'type',
        id: 'id',
        lastModified: 'lastModified'
      },
      opts: {},
      visible: false
    }
  },
  mounted () {
    this.images = this.value
    this.opts = Object.assign({}, this.defaultOptions, this.options)
  },
  methods: {
    onMouseover (e) {
      if (this.$refs.uploader) dom.addClass(this.$refs.uploader.$el, 'hover')
    },
    onMouseleave (e) {
      if (this.$refs.uploader) dom.removeClass(this.$refs.uploader.$el, 'hover')
    },
    changeStatus (file, response) {
      let index = this.images.findIndex(img => img.uid === file.uid)
      if (index !== -1) {
        this.images[index].status = file.status
        if (file.percentage) this.images[index].percentage = file.percentage
        if (response) this.images[index][this.opts.id] = response.id
      }
    },
    getUploadStatus (file) {
      return this.statusText[file.status] ? this.statusText[file.status] : `${Math.floor(file.percentage)}%`
    },
    onProgress (event, file, fileList) {
      this.changeStatus(file)
    },
    onSuccess (response, file, fileList) {
      this.changeStatus(file, response.data)
      this.$emit('on-success', response.data)
    },
    onBeforeUpload (file) {
      this.$emit('before-upload', file)
      if (this.images.length >= this.limit) {
        this.$emit('on-exceed', file)
        return false
      }
      if (file.type.indexOf('image') === -1) { // 检测主类型
        this.$emit('type-error', file)
        return false
      }
      if (this.maxSize && this.file.size > this.maxSize) {
        this.$emit('size-error', file)
        return false
      }
      let ext = file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.') + 1) : ''
      if (!ext) {
        this.$emit('type-error', file)
        return false
      }
      if (this.accept && this.accept.length && this.accept.indexOf(ext) === -1) {
        this.$emit('type-error', file)
        return false
      }
      let flag = true
      if (typeof this.beforeUpload === 'function') {
        flag = this.beforeUpload(file)
      }
      if (flag) {
        this.images.push({
          [this.opts.url]: file.url ? file.url : window.URL.createObjectURL(file),
          status: 'wait',
          raw: file,
          uid: file.uid,
          [this.opts.name]: file.name,
          [this.opts.size]: file.size,
          [this.opts.type]: file.type,
          [this.opts.lastModified]: file.lastModified,
          percentage: 0,
          ext: file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.') + 1) : ''
        })
        this.$emit('input', this.images)
      }
      return flag
    },
    onError (err, file, fileList) {
      console.error(err)
      this.changeStatus(file)
    },
    onDeleteFile (file) {
      let index = this.images.findIndex(img => img.uid === file.uid)
      if (index !== -1) {
        if (this.images[index].raw) this.$refs.uploader.abort(this.images[index].raw)
        this.images.splice(index, 1)
        this.$emit('input', this.images)
      }
    },
    onConfirm (list) {
      this.images = list
      this.$emit('input', this.images)
    }
  }
}
</script>

<style lang="scss">
    .image-uploader-wrapper {
        .image-uploader-list {
            display: inline-block;
            font-size: 0;
            vertical-align: middle;
            &:before,
            &:after {
                content: ' ';
                display: block;
                clear: both;
            }
            &-item {
                position: relative;
                float: left;
                width: 100px;
                height: 100px;
                margin-right: 10px;
                margin-bottom: 10px;
                cursor: pointer;
                &-img {
                    width: 100px;
                    height: 100px;
                }
                &.uploader {
                    width: 110px;
                    height: 110px;
                }
                 &.image {
                    background-color: #fff;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    padding: 4px;
                    box-sizing: content-box;
                    .uploader-delete-btn {
                        position: absolute;
                        background: #fff;
                        border: 0;
                        outline: 0;
                        border: 1px solid rgb(233, 233, 233);
                        border-radius: 50%;
                        font-size: 12px;
                        color: #f56c6c;
                        top: -10px;
                        left: -10px;
                        z-index: 2;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                        &:hover {
                            border-color: #409eff;
                        }
                    }
                    &:hover {
                        border-color: #409eff;
                        .uploader-delete-btn {
                            // animation: icon-rotating .2s infinite;
                        }
                        @keyframes icon-rotating {
                            0% {
                                transform: rotate(0deg)
                            }
                            50% {
                                transform: rotate(-10deg)
                            }
                            80% {
                                transform: rotate(10deg)
                            }
                            100% {
                                transform: rotate(0deg)
                            }
                        }
                    }
                }
                .image-name {
                    position: absolute;
                    width: calc(100% - 8px);
                    left: 4px;
                    bottom: 4px;
                    background: rgba(0, 0, 0, 0.5);
                    height: 20px;
                    text-align: center;
                    font-size: 12px;
                    color: #fff;
                    line-height: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    padding: 0 5px;
                    text-overflow: ellipsis;
                }
                .progress-bar {
                    height: 20px;
                    position: absolute;
                    left: 4px;
                    top: 4px;
                    width: calc(100% - 8px);
                    background: rgba(0, 0, 0, 0.5);
                    font-size: 12px;
                    line-height: 20px;
                    text-align: center;
                    color: #fff;
                    .progress {
                        width: 0;
                        height: 20px;
                        background: rgba(64, 158, 255, 0.8);
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 1;
                        transition: width .2s ease-in-out;
                        &.fail {
                            background: rgba(245, 108, 108, 0.8);
                            width: 100%;
                        }
                        &.success {
                            background: rgba(103, 194, 58,0.8);
                        }
                    }
                    .progress-text {
                        font-size: 12px;
                        color: #fff;
                        z-index: 2;
                        position: relative;
                    }
                }
            }
        }
        .image-uploader {
            position: relative;
            display: inline-flex;
            cursor: pointer;
            width: 110px;
            height: 110px;
            background: rgb(249, 249, 249);
            border: 1px solid rgb(233, 233, 233);
            color: #ccc;
            align-items: center;
            justify-content: center;
            vertical-align: middle;
            &-plus {
                font-size: 22px;
                color: rgb(204, 204, 204);
                font-style: normal;
                font-weight: bold;
                line-height: 20px;
            }
            &-tip {
                font-size: 14px;
                font-weight: 403;
                color: rgb(204, 204, 204);
                line-height: 1;
            }
            .uploader-mask {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
            }
            &.hover {
                background: #fff;
                border-color: #409eff;
                color: #409eff;
                .image-uploader-plus {
                    color: #409eff;
                }
                .image-uploader-tip {
                    color: #409eff;
                }
            }
            .uploader-tips {
                position: absolute;
                bottom: 2px;
                right: -5px;
                transform: translateX(100%);
                font-size: 12px;
                color: #999;
                display: inline-block;
                line-height: 1;
                width: max-content;
                cursor: default;
            }
        }
    }
    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }
    .list-enter {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-leave-to {
        opacity: 0;
        transform: translateY(-30px);
    }
</style>



// WEBPACK FOOTER //
// src/components/image-uploader.vue